import { Grid, Box } from "@mui/material";
import TextField from "../../shared/forms/fields/TextField";
import { useForm } from "react-hook-form";
import FormErrorAlert from "../../shared/forms/FormErrorAlert";
import SubmitButton from "../../shared/forms/SubmitButton";
import withFormStatus from "../../shared/forms/withFormStatus";
import {
  NurseAddStudyPatientForm,
  StudiesGetAllStudiesStudyModel,
} from "../../api";
import StickyFooter from "../../shared/layout/StickyFooter";
import BackButtonComponent from "shared/components/BackButton";
import DropDownField from "shared/forms/fields/DropDownField";
import DateField from "shared/forms/fields/DateField";
import { GenderEnum } from "shared";
import { StudyPatientStatusEnum } from "shared/models/study-patient-status.enum";

interface Props {
  studies: StudiesGetAllStudiesStudyModel[];
  onSave(form: NurseAddStudyPatientForm): void;
}

function AddStudyPatientForm({ onSave, studies }: Props) {
  const { control, handleSubmit, formState } =
    useForm<NurseAddStudyPatientForm>({
      mode: "onChange",
    });

  const onSubmit = handleSubmit((form) => onSave(form));

  return (
    <Box onSubmit={onSubmit} component="form">
      <FormErrorAlert />
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <TextField
            control={control}
            name="initials"
            label="Patient Initials"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            control={control}
            name="referenceId"
            label="Id"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownField
            options={GenderEnum}
            getOptionKey={(opt) => opt.key}
            getOptionLabel={(opt) => opt.label}
            control={control}
            name="gender"
            label="Gender"
          />
        </Grid>
        <Grid item xs={6}>
          <DateField control={control} name="dob" label="DOB" />
        </Grid>
        <Grid item xs={12}>
          <DropDownField
            options={studies}
            getOptionKey={(opt) => opt.id}
            getOptionLabel={(opt) => opt.name}
            control={control}
            name="studyId"
            label="Select Study"
            required
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            control={control}
            name="screeningNumber"
            label="Screening Number"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6}>
          <DropDownField
            options={StudyPatientStatusEnum}
            getOptionKey={(opt) => opt.key}
            getOptionLabel={(opt) => opt.label}
            control={control}
            name="status"
            label="Status"
          />
        </Grid>
      </Grid>
      <StickyFooter>
        <BackButtonComponent text="Cancel" />
        <SubmitButton variant="save" disabled={!formState.isValid} />
      </StickyFooter>
    </Box>
  );
}

export default withFormStatus(AddStudyPatientForm);
